import React from 'react';
import { Avatar } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import styles from '../../styles/chatV2.module.css';

const TypingIndicator = () => {
  return (
    <div className={styles.messageWrapper}>
      {/* AI Avatar */}
      <div className={styles.avatarContainer}>
        <Avatar
          size={36}
          icon={<RobotOutlined />}
          className={styles.aiAvatar}
        />
      </div>

      {/* Typing Animation */}
      <div className={styles.messageContent}>
        <div className={`${styles.messageBubble} ${styles.typingBubble}`}>
          <div className={styles.typingDots}>
            <span className={styles.typingDot}></span>
            <span className={styles.typingDot}></span>
            <span className={styles.typingDot}></span>
          </div>
        </div>
        <div className={styles.messageFooter}>
          <span className={styles.typingLabel}>AI is thinking...</span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
